import { render, staticRenderFns } from "./UserProducts.vue?vue&type=template&id=77bc60c4"
import script from "./UserProducts.vue?vue&type=script&lang=js"
export * from "./UserProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports